import script from "./MediaLayoutSplit.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaLayoutSplit.vue?vue&type=script&setup=true&lang=js"

import "./MediaLayoutSplit.vue?vue&type=style&index=0&id=0c302847&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c302847"]])

export default __exports__